import { render, staticRenderFns } from "./ActiveRules.vue?vue&type=template&id=1aaa6190"
import script from "./ActiveRules.vue?vue&type=script&lang=js"
export * from "./ActiveRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports